import React from 'react'

const MobileFilterRatings = () => {
	return (
		<div>
			<div className='mb-3'>
				<h5 className=' text-black text-normal'>Customer Ratings</h5>
			</div>
			<div class='form-check mb-2 '>
				<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
				<label class='custom-control-label ms-3' for='customCheck1'>
					<span className='text-black'>
						1 <i class='bi bi-star text-success'></i>
						<small className='text-dark ms-1'>(& above)</small>
					</span>
				</label>
			</div>
			<div class='form-check mb-2 '>
				<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
				<label class='custom-control-label ms-3' for='customCheck1'>
					<span className='text-black'>
						2 <i class='bi bi-star text-success'></i>
						<small className='text-dark ms-1'>(& above)</small>
					</span>
				</label>
			</div>
			<div class='form-check mb-2 '>
				<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
				<label class='custom-control-label ms-3' for='customCheck1'>
					<span className='text-black'>
						3 <i class='bi bi-star text-success'></i>
						<small className='text-dark ms-1'>(& above)</small>
					</span>
				</label>
			</div>
			<div class='form-check mb-2 '>
				<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
				<label class='custom-control-label ms-3' for='customCheck1'>
					<span className='text-black'>
						4 <i class='bi bi-star text-success'></i>
						<small className='text-dark ms-1'>(& above)</small>
					</span>
				</label>
			</div>
			<div class='form-check mb-2 '>
				<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
				<label class='custom-control-label ms-3' for='customCheck1'>
					<span className=' text-black'>
						5 <i class='bi bi-star text-success'></i>
						<small className='text-dark ms-1'>(& above)</small>
					</span>
				</label>
			</div>
		</div>
	)
}

export default MobileFilterRatings
